module.exports = __webpack_public_path__ + "img/software_img1.86ac1c2b.png";